<template>
  <v-container class="py-0">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-img
          :height="400"
          :alt="`Preview image: ${article.title}`"
          :lazy-src="require(`@/assets/blog-images/${article.imgUrl}?lqip`)"
          :src="require(`@/assets/blog-images/${article.imgUrl}`)"
        />

        <div class="pa-4">
          <h1 class="text-h4 mb-6">
            {{ article.title }}
          </h1>

          <nuxt-content :document="article" />
        </div>
        <v-divider />
        <cta-btns color-sub-cta="black" color="secondary" class="mx-auto my-10" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import AuthorWidget from '@/components/Author'
import CtaBtns from '@/components/CtaButtons'

const RENAMED_ARTICLES_MAP = {
  'difference-betwee-virtual-receptionists-and-virutal-assistant': 'difference-virtual-receptionists-virtual-assistant'
}

export default {
  components: {
    // AuthorWidget,
    CtaBtns
  },

  async asyncData({ $content, params, redirect }) {
    if (RENAMED_ARTICLES_MAP[params.slug]) {
      return redirect(301, RENAMED_ARTICLES_MAP[params.slug])
    }

    const article = await $content(`blog/${params.slug}`).fetch()

    // TODO: handle 404s
    return { article }
  },

  data: () => ({
    article: {}
  }),

  computed: {
    author() {
      return this.article?.author
    }
  },

  head() {
    return {
      title: `${this.article.title} - Blog`,
      meta: [
        { hid: 'description', name: 'description', content: this.article.description },
        // Open Graph
        { hid: 'og:title', property: 'og:title', content: this.article.title },
        { hid: 'og:description', property: 'og:description', content: this.article.description },
        // Twitter Card
        { hid: 'twitter:title', name: 'twitter:title', content: this.article.title },
        { hid: 'twitter:description', name: 'twitter:description', content: this.article.description }
      ]
    }
  }
}
</script>

<style lang="scss">
.nuxt-content {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0.8rem;
    margin-bottom: 0.5rem;
  }
  p,
  ul {
    font-size: 1.25rem;
    line-height: 1.6;
  }
}
</style>
